import dropdowns from './cards/dropdowns';
import formatters from './cards/formatters';
import sources from './cards/sources';
import stripe from './cards/stripe';

export default {
    mixins: [
        dropdowns,
        formatters,
        sources,
        stripe,
    ],
};
